import "./modules/common";
import VueApp from "~/Scripts/new/vueApp";
import SearchResults from "~/Components/Search/SearchResults.vue";
import SearchPagination from "~/Components/Search/SearchPagination.vue";
import SearchFilters from "~/Components/Search/SearchFilters.vue";

new VueApp( {
  name: "TestimonialArea",
  components: {
    SearchResults,
    SearchPagination,
    SearchFilters
  },
  mounted () {
    window.setTimeout( () => {
      const { hash } = window.location;
      const id = hash.replace( "#", "" );

      if ( id ) {
        this.$scrollTo( `#testimonial-${id}` );
      }
    }, 500 );
  }
} );
